@if (entitySummary) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <div class="entity-name">{{ entitySummary.entityName }}</div>
        <div class="entity-type-badge">{{ entitySummary.entityType }}</div>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      @if (!showTextView) {
        <div class="chart-container">
          <canvas
            baseChart
            [data]="barChartData"
            [options]="barChartOptions"
            [type]="barChartType">
          </canvas>
        </div>
      } @else {
        <div class="text-view">
          <table class="data-table">
            <thead>
              <tr>
                <th>Year</th>
                <th>Percentage</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (item of sortedYearPercentages; track item.year) {
                <tr>
                  <td>{{ item.year }}</td>
                  <td>{{ item.percentage.toFixed(2) }}%</td>
                  <td class="actions-cell">
                    <button mat-icon-button
                            (click)="onDeleteYear(item.year, $event)"
                            class="delete-button">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </mat-card-content>
  </mat-card>
}
